export default __webpack_public_path__ + "images/loggedout/icons/in_school_icon-b4f154190e2a9deab5b185f7aa5b0ce8.png";